import React, { useEffect } from 'react';

import { useContext as useUsersContext } from 'components/Users/Context';
import Header from './Header';
import Content from './Content';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  return (
    <div className="content">
      <Header />

      <Content />

    </div>
  );
}
